import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

const { VITE_ENVIRONMENT } = import.meta.env;

export default function getSettingsNavItems(
  args: Pick<
    NavItemArgs,
    | 'getUserAccessByCompany'
    | 'getUserAccessByComponent'
    | 'id'
    | 'isFullAdmin'
    | 'pathname'
    | 't'
  >,
) {
  const { getUserAccessByComponent, isFullAdmin, t, pathname, id } = args;
  const isTasksAvailable =
    getUserAccessByComponent(AccessComponentEnum.TasksManagement) !==
    AccessLevelEnum.LimitedRead;
  const isSitesAvailable =
    getUserAccessByComponent(AccessComponentEnum.SitesManagement) !==
    AccessLevelEnum.LimitedRead;
  const isAssetsAvailable =
    getUserAccessByComponent(AccessComponentEnum.AssetsManagement) !==
    AccessLevelEnum.LimitedRead;
  const nav: NavItem<undefined>[] = [];
  if (VITE_ENVIRONMENT === 'DEV') {
    nav.push({
      id: 'apiToken',
      title: t('api-token'),
      to: APP_URLS.dashboard.publicApi.getPathWithQuery(),
      type: NavItemTypeEnum.Primary,
      end: true,
      leftIcon: Icons.key,
    });
  }
  if (isSitesAvailable || isAssetsAvailable) {
    nav.push({
      id: 'import',
      title: t('import'),
      to: APP_URLS.dashboard.dataImport.getPathWithQuery(),
      type: NavItemTypeEnum.Primary,
      end: true,
      leftIcon: Icons.input,
    });
  }
  if (isTasksAvailable) {
    nav.push({
      id: 'checklists',
      title: t('forms-checklists'),
      to: APP_URLS.dashboard.formChecklists.index.getPathWithQuery(),
      type: NavItemTypeEnum.Primary,
      end: true,
      leftIcon: Icons.checklist,
      predictorFnActive: () => {
        return (
          APP_URLS.dashboard.formChecklists.add.isTheSameUrlAs(pathname) ||
          APP_URLS.dashboard.formChecklists.edit.isTheSameUrlAs(pathname, {
            pathParts: { id },
          })
        );
      },
    });
  }
  if (isFullAdmin) {
    nav.push({
      id: 'companyDomains',
      title: t('domains'),
      to: APP_URLS.dashboard.companyDomains.index.getPathWithQuery(),
      type: NavItemTypeEnum.Primary,
      end: true,
      leftIcon: Icons.domainVerification,
    });
  }
  if (isFullAdmin) {
    nav.push({
      id: 'sso',
      title: 'SSO',
      to: APP_URLS.dashboard.sso.index.getPathWithQuery(),
      type: NavItemTypeEnum.Primary,
      end: true,
      leftIcon: Icons.verifiedUser,
      predictorFnActive: () => {
        return (
          APP_URLS.dashboard.sso.add.isTheSameUrlAs(pathname) ||
          APP_URLS.dashboard.sso.view.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.sso.edit.isTheSameUrlAs(pathname, {
            pathParts: { id },
          })
        );
      },
    });
  }
  return nav;
}
